module.exports = __webpack_public_path__ + "static/together_event01_icon02-74d4e8916564deeb8da4bc663a838f3f.png";